import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SubscriberFn } from '@shared/utils/utils';

import { TrialInsightsClinicalQueryService } from './trial-insights-clinical-query.service';
import { TrialInsightsClinicalInvestigatorCostComponent } from '../trial-insights-clinical-investigator-cost/investigator-cost.component';
import { TrialInsightsClinicalPatientCostComponent } from '../trial-insights-clinical-patient-cost/patient-cost.component';
import { TrialInsightsClinicalScreenFailComponent } from '../trial-insights-clinical-screen-fail/screen-fail.component';
import { TrialInsightsClinicalSiteCostComponent } from '../trial-insights-clinical-site-cost/site-cost.component';
import { TrialInsightsClinicalTimelineComponent } from '../trial-insights-clinical-timeline/trial-insights-clinical-timeline.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsClinicalTimelineComponent,
    TrialInsightsClinicalPatientCostComponent,
    TrialInsightsClinicalInvestigatorCostComponent,
    TrialInsightsClinicalScreenFailComponent,
    TrialInsightsClinicalSiteCostComponent,
  ],
  templateUrl: './trial-insights-clinical.component.html',
})
export class TrialInsightsClinicalComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);
  private readonly queryService = inject(TrialInsightsClinicalQueryService);

  componentsLoading = true;
  trialLoading = true;

  ngOnInit(): void {
    this.queryService.pageLoading$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.processLoadingState);
  }

  processLoadingState: SubscriberFn<TrialInsightsClinicalQueryService['pageLoading$']> = (
    pageLoading
  ) => {
    const [trialLoading, componentsLoading] = pageLoading;

    this.trialLoading = trialLoading;
    this.componentsLoading = componentsLoading;

    this.cdr.markForCheck();
  };
}
